import React from "react";


import { ReactComponent as CancelIcon } from "static/images/cancel.svg";
import { ReactComponent as CheckIcon } from "static/images/checked.svg";
import styles from "./checkListRow.module.scss";

export type CheckListRowProps = { item: string; active: boolean };

const CheckListRow = ({ title, active }) => {
	const icon = active ? (
		<span className={styles.iconCheck}>
			<CheckIcon />
		</span>
	) : (
		<span className={styles.iconCross}>
			<CancelIcon />
		</span>
	);

	return (
		<li className={styles.row}>
			{icon} {title}
		</li>
	);
};

export default CheckListRow;
